/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Tooltip,
  Typography,
  Switch,
  AutoComplete,
  Select,
  Upload,
  Image,
  Skeleton,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  SettingOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  PlusCircleFilled,
  // CloseCircleFilled,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { isEmpty, isUndefined } from "lodash";
import { useHistory } from "react-router-dom";
// import { Prompt, useHistory } from "react-router-dom";
import moment from "moment";
import { BiCalendar, BiQrScan } from "react-icons/bi";
import axios from "axios";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import {
  loadSalesInvoice,
  loadSalesInvoiceRecordsMetaData,
  loadSearchImeiBarcodeList,
} from "../../store/sales-return/actions";
import {
  createPartiesList,
  loadParties,
  updatePartiesList,
} from "../../store/parties/actions";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../helpers";
import {
  loadFinancialYearList,
  loadPrefixSettingsList,
} from "../../store/expenses/actions";

const CreateSalesReturn = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const organizationName = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationName
    : "";
  const poNoValue =
    props && !isEmpty(props.state) && props.state ? props.state : "1";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const salesReturnList = { organizationId: organizationId };

  const updatedData =
    props.location && props.location.state
      ? props.location.state.salesInvoiceData
      : "";

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //initial loading states

  const [additionalOptions, setAdditionalOptions] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [partyMode, setPartyMode] = useState("");
  const [autoRoundOffMethod, setAutoRoundOffMethod] = useState([]);
  const [poDate, setPoDate] = useState("");
  const [biller, setBiller] = useState([]);
  const [billerId, setBillerId] = useState("");
  const [poNo, setPoNo] = useState("");
  const [orgInvoiceNo, setOrgInvoiceNo] = useState("");

  const [fullyPaid, setFullyPaid] = useState("");
  // const [amountPaid, setAmountPaid] = useState("");
  const [amountPaidList, setAmountPaidList] = useState([]);

  //Initial load
  const salesPrefixList = {
    organizationId: organizationId,
    isType: "isSalesReturn",
  };
  const poDateValue = moment().format("YYYY-MM-DD");
  // const validDateValue = moment().add(1, "month").format("YYYY-MM-DD");

  useEffect(() => {
    setAdditionalOptions({
      value: "No Tax Applicable",
      label: "No Tax Applicable",
    });
    setDiscount({
      value: "Display After Tax",
      label: "Display After Tax",
    });
    setAutoRoundOffMethod("add");
    if (poNoValue) {
      setPoNo(poNoValue);
    }
    setPoDate(poDateValue);
    // setValidDate(validDateValue);
    setAmountPaidList("creditbalance");
    dispatch(loadSalesInvoiceRecordsMetaData());
    dispatch(loadFinancialYearList());
    dispatch(loadPrefixSettingsList(salesPrefixList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePoDateChange = (date) => {
    setPoDate(date);
  };

  //reducer state
  const { parties_list = [] } = useSelector((state) => state.Parties);
  const { financial_year_list = [], prefix_settings_list = [] } = useSelector(
    (state) => state.Expenses
  );

  const {
    recordsMetaData = {},
    // party_address_list = [],
    search_imei_barcode = [],
  } = useSelector((state) => state.SalesReturn);

  const barcodeOptions =
    search_imei_barcode && search_imei_barcode.length > 0
      ? search_imei_barcode.map((data) => {
          return {
            label: data.barcodeNo,
            value: data._id,
          };
        })
      : [];

  const financialyearId =
    financial_year_list && financial_year_list.length > 0
      ? financial_year_list[0]._id
      : "";

  const [partyModalData, setPartyModalData] = useState({
    mobile: "",
    partyName: "",
    cityName: "",
    gstIn: "",
    billingAddress: "",
    totalAddress: "",
    state: "",
    billingCityName: "",
    billingAddressValue: "",
    totalBillingAddress: "",
    billingState: "",
    vendorId: "",
    partyId: "",
    _id: "",
  });

  const handleModalChange = (e) => {
    setPartyModalData({
      ...partyModalData,
      [e.target.name]: e.target.value,
    });
  };

  // useEffect(() => {
  //   if (party_address_list && party_address_list.length > 0) {
  //     setPartyAddressData(party_address_list);
  //   }
  // }, [party_address_list]);

  //party vendor state modal section
  const [sameAs, setSameAs] = useState("");
  const [stateData, setStateData] = useState([]);
  const [pincode, setPincode] = useState("");
  const [billingStateData, setBillingStateData] = useState([]);
  const [billingPincode, setBillingPincode] = useState("");
  const [partyModal, setPartyModal] = useState(false);
  const [createPartyModal, setCreatePartyModal] = useState(false);
  const [addAddressShow, setAddAddressShow] = useState(false);
  const [addGstShow, setAddGstShow] = useState(false);

  //parties rows
  const [vendorRows, setVendorRows] = useState([
    {
      partyName: "",
      partyNameValue: "",
      partyCode: "",
      mobileNo: "",
      billingAddress: [],
      shippingAddress: [],
      openingbalanceType: "",
      _id: "",
      state: "",
      currentBalance: "",
      status: "",
    },
  ]);

  const vendorDataTable =
    parties_list && parties_list.length > 0
      ? parties_list.map((data, index) => {
          return {
            index: index + 1,
            billingAddress: data.billingAddress,
            shippingAddress: data.shippingAddress,
            _id: data._id,
            creditBalance: data.creditBalance,
            mobileNo: data.mobileNo,
            currentBalance: data.currentBalance,
            openingbalanceType: data.openingbalanceType,
            partyName: data.partyName ? data.partyName : "",
            creditLimit: data.creditLimit ? data.creditLimit : "--",
            displayName: data.displayName ? data.displayName : "--",
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (vendorDataTable && vendorDataTable.length > 0) {
      setVendorRows(vendorDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parties_list]);

  //data table
  const [search, setSearch] = useState("");
  const [tableLoading, setTableLoading] = useState(false);

  const handleSearch = (event) => {
    const filteredRows = vendorDataTable
      .filter((row) =>
        row.partyName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setVendorRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const purchasePartyData = {
    organizationId: organizationId,
    partyName: partyModalData.partyName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddress,
        // address2: "Suite 456",
        country: "India",
        state: stateData,
        pincode: pincode,
        city: partyModalData.cityName,
      },
    ],
    createdBy: userId,
  };

  const purchasePartyObj = Object.keys(purchasePartyData).forEach(
    (k) => !purchasePartyData[k] && delete purchasePartyData[k]
  );
  const purchaseUpdatePartyData = {
    vendorId: partyModalData._id,
    organizationId: organizationId,
    partyName: partyModalData.partyName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddressValue,
        // address2: "Suite 456",
        country: "India",
        state: billingStateData,
        pincode: billingPincode,
        city: partyModalData.billingCityName,
      },
    ],
    createdBy: userId,
  };

  const purchaseUpdatePartyObj = Object.keys(purchaseUpdatePartyData).forEach(
    (k) => !purchaseUpdatePartyData[k] && delete purchaseUpdatePartyData[k]
  );

  console.log(purchasePartyObj, "purchasePartyObj");
  console.log(purchaseUpdatePartyObj, "purchaseUpdatePartyObj");

  const [validations, setValidations] = useState(false);
  //create items list
  const createPartiesApi = () => {
    if (
      !isEmpty(partyModalData.partyName) &&
      !isEmpty(partyModalData.billingAddress) &&
      !isEmpty(partyModalData.mobile)
    ) {
      dispatch(createPartiesList(purchasePartyData));

      setTimeout(() => {
        dispatch(loadParties(salesReturnList));
        toast.success("Customer Added Successfully");
        setCreatePartyModal(false);
        setValidations(false);
      }, 2000);
    } else {
      setValidations(true);
    }
  };
  //create items list
  const updatePartiesApi = () => {
    if (!isEmpty(partyModalData.partyName)) {
      // if (simpleValidator.current.allValid()) {
      dispatch(updatePartiesList(purchaseUpdatePartyData));

      setTimeout(() => {
        dispatch(loadParties(salesReturnList));
        toast.success("Customer Updated Successfully");
        setCreatePartyModal(false);
      }, 2000);
    } else {
      setValidations(true);
    }
  };
  const getFilteredBarcodes = (currentBarcode) => {
    const selectedBarcodes = itemSelectedRows
      .map((row) => row.barcode)
      .filter((barcode) => barcode); // Exclude empty selections
    console.log(selectedBarcodes, "selectedBarcodes");
    const barcodeOptionsArray = barcodeOptions.filter(
      (barcode) =>
        !selectedBarcodes.includes(barcode.label) ||
        barcode.label === currentBarcode
    );
    console.log(barcodeOptionsArray, "barcodeOptionsArray");
    return barcodeOptionsArray;
  };
  //purchase State values
  const [notesOpen, setNotesOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [additionalChargesOpen, setAdditionalChargesOpen] = useState(false);
  const [discountOpen, setDiscountOpen] = useState(false);
  const [autoRoundOff, setAutoRoundOff] = useState(false);

  const [notes, setNotes] = useState("");
  const [termsConditions, setTermsConditions] = useState("");

  const [totalSectionData, setTotalSectionData] = useState({
    chargesData: "",
    additionalCharges: "",
    discountPercent: "",
    discountAmount: "",
    autoRoundOffValue: "",
    amountPaid: "",
    totalAmount: "",
    tcsTaxName: "",
    tcsSectionName: "",
    siId: "",
    tcsRatePercent: "",
    tdsTaxName: "",
    tdsSectionName: "",
    tdsRatePercent: "",
    chargeId: "",
  });

  const handlePurchaseChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      discountPercent: /^[0-9]\d*\.?\d*$/,
      discountAmount: /^\d*\.?\d*$/,
      autoRoundOffValue: /^\d*\.?\d*$/,
      totalAmount: /^\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setTotalSectionData({
          ...totalSectionData,
          [name]: value,
        });
      }
    } else {
      setTotalSectionData({
        ...totalSectionData,
        [name]: value,
      });
    }

    if (name === "discountPercent") {
      const discountPercentageValue = totals.totalAmount
        ? parseInt((totals.totalAmount * value) / 100)
        : 0;
      setTotalSectionData({
        ...totalSectionData,
        discountAmount: discountPercentageValue,
      });
    }
  };

  //Item create modal
  // const [createItemModal, setCreateItemModal] = useState(false);
  const [quantityShow, setQuantityShow] = useState(false);
  const [pageRender, setPageRender] = useState(false);
  const [purchasePriceModal, setPurchasePriceModal] = useState(false);
  const [renderPage, setRenderPage] = useState(false);

  // const handleClose = (data) => {
  //   setCreateItemModal(data);
  // };

  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  };

  const [itemSelectedRows, setItemSelectedRows] = useState([
    {
      itemName: "",
      itemChecked: "",
      itemNameValue: "",
      barcode: "",
      barcodeName: "",
      barcodeList: "",
      grade: "",
      gradeName: "",
      totalDiscountAmount: "",
      serialId: "",
      qty: "",
      ramId: "",
      ramName: "",
      model: "",
      brand: "",
      brandName: "",
      serialDetails: [],
      imeiCode: "",
      salesPrice: "",
      purchasePrice: "",
      discountPrice: "",
      discountPercentage: "",
      totalAmount: "",
      stockQTY: "",
      stockAge: "",
      createdDate: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  //add items new row
  const addItemsNew = () => {
    setRenderPage(!renderPage);
    setItemSelectedRows([
      ...itemSelectedRows,
      {
        itemName: "",
        itemChecked: "",
        serialDetails: [],
        itemNameValue: "",
        barcode: "",
        barcodeName: "",
        barcodeList: "",
        grade: "",
        gradeName: "",
        qty: "",
        serialId: "",
        ramId: "",
        ramName: "",
        totalDiscountAmount: "",
        model: "",
        brand: "",
        brandName: "",
        imeiCode: "",
        salesPrice: "",
        purchasePrice: "",
        discountPrice: "",
        discountPercentage: "",
        totalAmount: "",
        stockQTY: "",
        stockAge: "",
        createdDate: "",
        _id: "",
        index: "",
        action: "",
        status: "",
      },
    ]);
  };

  const [arraySelectedId, setArraySelectedId] = useState("");
  const [barcodeKey, setBarcodeKey] = useState(false);
  const removeItemsData = (index) => {
    console.log(index, "index");
    const array = [...itemSelectedRows];
    array.splice(index, 1);
    setItemSelectedRows(array);
    setPageRender(!pageRender);
    // if (index !== 0) {
    //   if (index > -1) {
    //     array.splice(index, 1);
    //   }
    // }
  };

  //item Selected on change
  const itemSelectedChange = (e, name, index) => {
    var itemList = itemSelectedRows;

    if (name == "barcode") {
      if (e.label) {
        api
          .post("/org/getreturndatabybarcodeorimei", {
            organizationId: organizationId,
            Barcode: e.label,
          })
          .then((res) => {
            const response = res.data;
            const serialDetails =
              response && response.serialDetails.length > 0
                ? response.serialDetails[0]
                : "";
            const diff1 = moment();
            const diff2 = moment(serialDetails.dateCreated);
            const stockAge = !isEmpty(serialDetails)
              ? parseInt(diff1.diff(diff2, "days"))
              : "";
            if (response) {
              itemList[index]["barcode"] = e.label;
              itemList[index]["barcodeList"] = e;
              itemList[index]["model"] = response.modelName;
              itemList[index]["qty"] = response.qty;
              itemList[index]["itemName"] = response.modelName;
              itemList[index]["brand"] = response.brandId;
              itemList[index]["brandName"] = response.brandName;
              itemList[index]["ramId"] = !isEmpty(serialDetails)
                ? serialDetails.RAM
                : "";
              itemList[index]["serialId"] = serialDetails
                ? serialDetails.serialId
                : "";
              itemList[index]["ramName"] = !isEmpty(serialDetails)
                ? serialDetails.ramName
                : "";
              itemList[index]["grade"] = !isEmpty(serialDetails)
                ? serialDetails.grade
                : "";
              itemList[index]["gradeName"] = !isEmpty(serialDetails)
                ? serialDetails.gradeName
                : "";
              itemList[index]["salesPrice"] = !isEmpty(serialDetails)
                ? serialDetails.sellingPrice &&
                  parseFloat(serialDetails.sellingPrice).toFixed(2)
                : "";
              itemList[index]["totalAmount"] = !isEmpty(serialDetails)
                ? serialDetails.sellingPrice &&
                  parseFloat(serialDetails.sellingPrice).toFixed(2)
                : "";
              itemList[index]["barcodeName"] = !isEmpty(serialDetails)
                ? serialDetails.barcodeName
                : "";
              itemList[index]["purchasePrice"] = !isEmpty(serialDetails)
                ? serialDetails.purchasePrice
                : "";
              itemList[index]["createdDate"] = !isEmpty(serialDetails)
                ? serialDetails.dateCreated
                : "";
              itemList[index]["stockAge"] = !isEmpty(serialDetails)
                ? stockAge
                : "";
              itemList[index]["imeiCode"] = !isEmpty(serialDetails)
                ? serialDetails.IMEI
                : "";
              setRenderPage(!renderPage);
              setItemSelectedRows(itemList);
              addItemsNew();
            }

            return res.data;
          });
      }
    }
    if (name == "imeiCode") {
      e = e.target.value;
      itemList[index][name] = e;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "salesPrice") {
      e = e.target.value;

      const discountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? itemList[index].discountPrice
          : 0;
      const totalAmountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? parseInt(e - discountPrice)
          : parseInt(e);

      itemList[index][name] = e;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["totalAmount"] = parseFloat(totalAmountPrice).toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPrice") {
      e = e.target.value;
      const totalAmountData =
        itemList[index].salesPrice && itemList[index].salesPrice;

      const discountPrice = parseInt(totalAmountData - e);

      itemList[index][name] = e;
      itemList[index]["totalAmount"] =
        e > 0
          ? parseFloat(discountPrice).toFixed(2)
          : parseFloat(totalAmountData).toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "totalAmount") {
      e = e.target.value;
      itemList[index][name] = e && parseFloat(e).toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let salesPrice = 0;
    let discountPrice = 0;
    let totalAmount = 0;
    let discountedValue = 0;
    let totalDiscountAmount = 0;

    rows.forEach((row) => {
      salesPrice += parseFloat(row.salesPrice) || 0;
      discountPrice += parseFloat(row.discountPrice) || 0;
      totalAmount += parseFloat(row.totalAmount) || 0;
      totalDiscountAmount += parseFloat(row.totalAmount) || 0;
      discountedValue += row.discountPrice
        ? parseFloat(row.totalAmount - row.discountPrice)
        : row.totalAmount || 0;
    });

    return {
      salesPrice,
      discountPrice,
      totalDiscountAmount,
      totalAmount,
      discountedValue,
    };
  };

  const [totals, setTotals] = React.useState({
    salesPrice: 0,
    discountPrice: 0,
    discountedValue: 0,
    finalDiscountPrice: 0,
    totalQty: 0,
    totalDiscountAmount: 0,
    totalAmount: 0,
  });

  const handleTotalChange = (e) => {
    setTotals({
      ...totals,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "discountPrice") {
      const totalAmountFromItems = e.target.value
        ? parseInt(totals.totalAmount - e.target.value)
        : totals.totalAmount;
      setTotals({
        ...totals,
        discountedValue: totalAmountFromItems,
      });
    }
  };

  useEffect(() => {
    const newTotals = calculateTotals(itemSelectedRows);
    setTotals(newTotals);
  }, [itemSelectedRows, renderPage]);

  //Serialisation
  const [serialOpenStock, setSerialOpenStock] = useState("");
  const [serialData, setSerialData] = useState([
    {
      serialNo: "",
    },
  ]);

  const addSerialData = () => {
    setSerialData([
      ...serialData,
      {
        serialNo: "",
      },
    ]);
    // setSerialDataAdd(true);
    setPageRender(!pageRender);
  };

  const removeSerialData = (index) => {
    const array = serialData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
        setSerialOpenStock(array.length);
      }
    }
    setPageRender(!pageRender);
  };

  const handleSerialDataChange = (e, name, index) => {
    var fieldList = serialData;
    if (name === "serialNo") {
      fieldList[index][name] = e.target.value;
      setSerialData(fieldList);
      setSerialOpenStock(fieldList.length);
      setPageRender(!pageRender);
    }
  };

  //settings States data
  const [pageRouting, setPageRouting] = useState(false);
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);

  const [prefixSettings, setPrefixSettings] = useState({
    prefix: "",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPrefixSettings({
      ...prefixSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //Image upload
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleImageChange = ({ fileList: newFileList }) => {
    var fileArrayDetails =
      newFileList && newFileList.length > 0 ? newFileList[0].originFileObj : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);
    setTimeout(() => {
      api
        .post(`/img/upload`, formData)
        .then(async (res) => {
          if (res && res.data) {
            await setFileList([res.data.file]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
        });
    }, 1000);
  };

  //upload btn
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
          fontFamily: "Poppins",
          fontSize: "13px",
        }}
      >
        Add Signature
      </div>
    </button>
  );

  const roundOffFinalValues = totalSectionData.autoRoundOffValue
    ? parseFloat(totalSectionData.autoRoundOffValue)
    : "";
  const additionalChargesFinalValues = totalSectionData.additionalCharges
    ? parseFloat(totalSectionData.additionalCharges)
    : "";
  const dicountAmountValues = totalSectionData.discountAmount
    ? parseFloat(totalSectionData.discountAmount)
    : "";
  //Po net amount
  const discountFinalAmount =
    autoRoundOffMethod == "reduce" && additionalChargesFinalValues == ""
      ? parseFloat(totals.totalAmount + roundOffFinalValues)
      : autoRoundOffMethod == "reduce" && additionalChargesFinalValues !== ""
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues -
            roundOffFinalValues
        )
      : additionalChargesFinalValues == ""
      ? parseFloat(totals.totalAmount + roundOffFinalValues)
      : autoRoundOffMethod == "add" &&
        additionalChargesFinalValues !== "" &&
        roundOffFinalValues !== ""
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues +
            roundOffFinalValues
        )
      : parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues +
            roundOffFinalValues
        );
  const roundOffFinalWithTotal =
    autoRoundOffMethod == "reduce"
      ? parseFloat(totals.totalAmount - roundOffFinalValues)
      : parseFloat(totals.totalAmount + roundOffFinalValues);
  const netAmount =
    itemSelectedRows &&
    itemSelectedRows.length > 0 &&
    totalSectionData.additionalCharges == "" &&
    // isEmpty(updatedData) &&
    totalSectionData.autoRoundOffValue == "" &&
    totalSectionData.discountAmount == ""
      ? totals.totalAmount
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges == "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount == ""
      ? roundOffFinalWithTotal
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges == "" &&
        totalSectionData.autoRoundOffValue == "" &&
        totalSectionData.discountAmount != ""
      ? parseFloat(discountFinalAmount - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges !== "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount !== ""
      ? parseFloat(discountFinalAmount - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges == "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount !== ""
      ? parseInt(roundOffFinalWithTotal - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges !== "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount == ""
      ? discountFinalAmount
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? roundOffFinalWithTotal
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        totalSectionData.discountAmount !== ""
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues -
            dicountAmountValues
        )
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? parseFloat(totals.totalAmount + additionalChargesFinalValues)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        !isEmpty(updatedData) &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? parseInt(totals.totalAmount + totalSectionData.additionalCharges)
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        !isEmpty(totalSectionData.discountAmount)
      ? parseInt(roundOffFinalWithTotal - dicountAmountValues)
      : 0;
  // const diffAmount = parseInt(netAmount - amountPaid);
  // const initialAmount = diffAmount !== 0 ? amountPaid : 0;

  //Po add api payloads
  const salesReturnListData = {
    partyId: partyModalData._id,
    organizationId: organizationId,
    billerId: biller,
    returnsalesinvoiceNo: poNo,
    orginvoiceNo: orgInvoiceNo ? orgInvoiceNo : 1,
    isType:
      prefix_settings_list && prefix_settings_list.isEnable == true
        ? "isSalesReturn"
        : "",
    returnsalesinvoiceDate: poDate,
    financialyearId: financialyearId,
    customerMobileNo: partyModalData.mobile,
    // paymentTerms: paymentTerms,
    // dueDate: validDate,
    isSumcb: amountPaidList === "currentBalance" ? true : false,
    isSumcrb: amountPaidList === "creditbalance" ? true : false,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            return {
              serialId: data.serialId,
              // itemName: data.itemName,
              ramId: data.ramId,
              imeiNo: data.imeiCode,
              sellingPrice: data.salesPrice,
              discountAmount: data.discountPrice,
              totalAmount: data.totalAmount,
            };
          })
        : [],
    charges: totalSectionData.chargesData
      ? [
          {
            chargeName: totalSectionData.chargesData
              ? totalSectionData.chargesData
              : "",
            chargeAmount: totalSectionData.additionalCharges,
          },
        ]
      : [],
    individualtotalDiscount: totals.discountPrice ? totals.discountPrice : 0,
    discountPercentage: totalSectionData.discountPercent
      ? totalSectionData.discountPercent
      : 0,
    overallDiscount: totalSectionData.discountAmount
      ? totalSectionData.discountAmount
      : 0,
    notes: notes,
    // amountreceived: parseInt(amountPaid),
    netTotalAmount: netAmount,
    // amountreceivedmode: amountPaidList,
    termsandconditions: termsConditions,
    // balanceAmount: totalBalanceAmount,
    markasfullypaid: fullyPaid === true ? true : false,
    autoroundoff: autoRoundOff === true ? true : false,
    type:
      autoRoundOffMethod && !isEmpty(autoRoundOffMethod.value)
        ? autoRoundOffMethod.value
        : autoRoundOffMethod,
    autoroundoffamount:
      autoRoundOff === true && totalSectionData.autoRoundOffValue
        ? parseInt(totalSectionData.autoRoundOffValue)
        : 0,
    authorizedsignatur: fileList ? fileList[0] : "",
    // initialAmount: parseInt(initialAmount),
    createdBy: userId,
  };

  //update objects
  const salesInvoiceUpdateListData = {
    riId: partyModalData._id,
    organizationId: organizationId,
    billerId: !isEmpty(billerId) ? billerId : biller,
    _id: totalSectionData.chargeId,
    partyId: partyModalData.vendorId,
    returnsalesinvoiceNo: poNo,
    orginvoiceNo: orgInvoiceNo ? orgInvoiceNo : 1,
    isType:
      prefix_settings_list && prefix_settings_list.isEnable == true
        ? "isSalesReturn"
        : "",
    siId: totalSectionData.siId,
    returnsalesinvoiceDate: poDate,
    financialyearId: financialyearId,
    customerMobileNo: partyModalData.mobile,
    // paymentTerms: paymentTerms,
    // dueDate: validDate,
    isSumcrb: amountPaidList === "creditbalance" ? true : false,
    isSumcb: amountPaidList === "currentBalance" ? true : false,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            return {
              itemId: data._id,
              itemName: data.itemName,
              sellingPrice: data.salesPrice,
              discountAmount: data.discountPrice,
              totalAmount: data.totalAmount,
              qty: data.qty,
              serialDetails:
                data.serialDetails.length > 0
                  ? data.serialDetails.map((serial) => {
                      return {
                        serialId: serial.serialId,
                        dateCreated: serial.dateCreated,
                        barCodeNo: serial.barCodeNo,
                        imeiNo: serial.imeiCode,
                        ramName: serial.ramName,
                        sellingPrice: data.salesPrice
                          ? parseFloat(data.salesPrice)
                          : serial.sellingPrice,
                        discountAmount: data.discountPrice
                          ? parseFloat(data.discountPrice)
                          : serial.discountAmount,
                        totalAmount: data.totalAmount
                          ? parseFloat(data.totalAmount)
                          : serial.totalAmount,
                      };
                    })
                  : [],
            };
          })
        : [],
    charges: totalSectionData.chargesData
      ? [
          {
            chargeName: totalSectionData.chargesData
              ? totalSectionData.chargesData
              : "",
            chargeAmount: totalSectionData.additionalCharges,
            _id: totalSectionData.chargeId,
          },
        ]
      : [],
    individualtotalDiscount: totals.discountPrice ? totals.discountPrice : 0,
    discountPercentage: totalSectionData.discountPercent
      ? totalSectionData.discountPercent
      : 0,
    overallDiscount: totalSectionData.discountAmount
      ? totalSectionData.discountAmount
      : 0,
    notes: notes,
    // amountreceived: parseInt(amountPaid),
    netTotalAmount: netAmount,
    // amountreceivedmode: amountPaidList,
    termsandconditions: termsConditions,
    // balanceAmount: totalBalanceAmount,
    markasfullypaid: fullyPaid === true ? true : false,
    autoroundoff: autoRoundOff === true ? true : false,
    type:
      autoRoundOffMethod && !isEmpty(autoRoundOffMethod.value)
        ? autoRoundOffMethod.value
        : autoRoundOffMethod,
    autoroundoffamount:
      autoRoundOff === true && totalSectionData.autoRoundOffValue
        ? parseInt(totalSectionData.autoRoundOffValue)
        : 0,
    authorizedsignatur: fileList ? fileList[0] : "",
    // initialAmount: parseInt(initialAmount),
    createdBy: userId,
  };

  const salesReturnListArray = Object.keys(salesReturnListData).forEach(
    (k) =>
      (salesReturnListData[k] === undefined || salesReturnListData[k] === "") &&
      delete salesReturnListData[k]
  );
  const salesInvoiceUpdateList = Object.keys(
    salesInvoiceUpdateListData
  ).forEach(
    (k) =>
      (salesInvoiceUpdateListData[k] === undefined ||
        salesInvoiceUpdateListData[k] === "") &&
      delete salesInvoiceUpdateListData[k]
  );

  console.log(salesReturnListArray, "salesReturnListArray");
  console.log(salesInvoiceUpdateList, "salesInvoiceUpdateList");
  const barcodeMandatory =
    itemSelectedRows && itemSelectedRows.length > 0
      ? itemSelectedRows.filter(
          (data) =>
            data.barcode == null ||
            data.barcode == "" ||
            data.barcode == undefined
        )
      : [];
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //Create sales return
  const createSalesInvoiceApi = () => {
    if (
      simpleValidator.current.allValid() &&
      partyModalData.billingAddressValue &&
      barcodeMandatory.length == 0
      // poNo !== "" &&
      // !isEmpty(biller) &&
      // // !isEmpty(paymentTerms) &&
      // partyModalData.billingAddressValue &&
      // salesPriceMandatory.length == 0 &&
      // barcodeMandatory.length == 0
    ) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 7000);
      api
        .post("/org/createreturninvoice", salesReturnListData)
        .then((res) => {
          toast.success("Sales Return created successfully ");
          dispatch(loadSalesInvoice(salesReturnList));
          // history.push("/sales-return");
          setTimeout(() => {
            history.push("/sales-return");
          }, 1500);

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          console.log(error, "error");
          console.log(errorMsg, "errorMsg");
          toast.error(
            errorMsg || "There is a an issue while adding the purchase"
          );
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (
        !isEmpty(partyModalData.billingAddressValue) &&
        barcodeMandatory.length == 0
      ) {
        console.log("no error");
      } else {
        toast.error(
          `${
            isEmpty(partyModalData.billingAddressValue) &&
            barcodeMandatory.length > 0
              ? "Billing from, barcode field is required"
              : !isEmpty(partyModalData.billingAddressValue) &&
                barcodeMandatory.length > 0
              ? "Barcode field is required"
              : isEmpty(partyModalData.billingAddressValue) &&
                barcodeMandatory.length == 0
              ? "Billing from field is required"
              : ""
          }`
        );
      }
    }
  };

  //update Sales Return orders
  const updateSalesInvoiceApi = () => {
    if (
      simpleValidator.current.allValid() &&
      partyModalData.billingAddressValue &&
      barcodeMandatory.length == 0
      // poNo !== "" &&
      // !isEmpty(biller) &&
      // // !isEmpty(paymentTerms) &&
      // partyModalData.billingAddressValue &&
      // salesPriceMandatory.length == 0 &&
      // barcodeMandatory.length == 0
    ) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 7000);
      api
        .post("/org/updatereturninvoices", salesInvoiceUpdateListData)
        .then((res) => {
          toast.success("Sales Return updated successfully");
          dispatch(loadSalesInvoice(salesReturnList));
          setTimeout(() => {
            history.push("/sales-return");
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg);
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (
        !isEmpty(partyModalData.billingAddressValue) &&
        barcodeMandatory.length == 0
      ) {
        console.log("no error");
      } else {
        toast.error(
          `${
            isEmpty(partyModalData.billingAddressValue) &&
            barcodeMandatory.length > 0
              ? "Billing from, barcode field is required"
              : !isEmpty(partyModalData.billingAddressValue) &&
                barcodeMandatory.length > 0
              ? "Barcode field is required"
              : isEmpty(partyModalData.billingAddressValue) &&
                barcodeMandatory.length == 0
              ? "Billing from field is required"
              : ""
          }`
        );
      }
    }
  };

  useBeforeUnload({
    when: !isEmpty(totalSectionData),
    message: "Are you sure you want to leave?",
  });

  //updated data
  useEffect(() => {
    if (updatedData) {
      const partyAddressDetails =
        updatedData && updatedData.partyAddress.length > 0
          ? updatedData.partyAddress[0]
          : "";
      setPartyModalData({
        ...partyModalData,
        _id: updatedData ? updatedData._id : "",
        partyName: updatedData ? updatedData.partyName : "",
        partyId: updatedData ? updatedData.partyId : "",
        mobile: updatedData ? updatedData.customerMobileNo : "",
        totalAddress: partyAddressDetails
          ? partyAddressDetails.address1 + ", " + partyAddressDetails.city
          : "",
        billingAddress: partyAddressDetails ? partyAddressDetails.address1 : "",
        cityName: partyAddressDetails ? partyAddressDetails.city : "",
        state: partyAddressDetails ? partyAddressDetails.state : "",
        billingAddressValue: partyAddressDetails
          ? partyAddressDetails.address1
          : "",
        billingCityName: partyAddressDetails ? partyAddressDetails.city : "",
        billingState: partyAddressDetails ? partyAddressDetails.state : "",
        vendorId: updatedData ? updatedData.partyId : "",
      });
      setBillingStateData("Tamil Nadu");
      setBillingPincode(partyAddressDetails.pincode);
      const updatedPoNo = updatedData ? updatedData.returnsalesinvoiceNo : "";
      const updatedPoDate = updatedData
        ? moment(updatedData.salesinvoiceDate).format("YYYY-MM-DD")
        : "";
      dispatch(
        loadSearchImeiBarcodeList({
          organizationId: organizationId,
          partyId: updatedData.partyId,
        })
      );
      // const updatedValidDate =
      //   updatedData && updatedData.dueDate
      //     ? moment(updatedData.dueDate).format("YYYY-MM-DD")
      //     : "";
      const updatedOrgInvoiceNo =
        updatedData && updatedData.orginvoiceNo ? updatedData.orginvoiceNo : "";
      // const updatedPaymentTerms =
      //   updatedData && updatedData.paymentTerms ? updatedData.paymentTerms : "";
      setPoNo(updatedPoNo);
      setOrgInvoiceNo(updatedOrgInvoiceNo);
      setPoDate(updatedPoDate);
      // setValidDate(updatedValidDate);
      // setPaymentTerms(updatedPaymentTerms);

      dispatch(loadSalesInvoiceRecordsMetaData());
      const updatedItemValues =
        updatedData && updatedData.items.length > 0
          ? updatedData.items.map((data) => {
              const serialDetails =
                data.serialDetails && data.serialDetails.length > 0
                  ? data.serialDetails[0]
                  : "";
              const diff1 = moment();
              const diff2 = moment(serialDetails.dateCreated);
              const stockAge = !isEmpty(serialDetails)
                ? parseInt(diff1.diff(diff2, "days"))
                : "";
              return {
                itemName: data.modelName,
                brand: data.brandId,
                brandName: data.brandName,
                model: data.modelName,
                itemChecked: "",
                itemNameValue: "",
                qty: data.qty,
                barcode: serialDetails ? serialDetails.barCodeNo : "",
                barcodeName: serialDetails ? serialDetails.barCodeNo : "",
                barcodeList: "",
                serialDetails: data.serialDetails,
                grade: serialDetails ? serialDetails.gradeName : "",
                gradeName: serialDetails ? serialDetails.gradeName : "",
                serialId: serialDetails ? serialDetails.serialId : "",
                RAM: serialDetails ? serialDetails.RAM : "",
                ramName: serialDetails ? serialDetails.ramName : "",
                imeiCode: serialDetails ? serialDetails.IMEI : "",
                salesPrice:
                  serialDetails && serialDetails.sellingPrice
                    ? parseFloat(serialDetails.sellingPrice).toFixed(2)
                    : "",
                purchasePrice:
                  serialDetails && serialDetails.purchasePrice
                    ? parseFloat(serialDetails.purchasePrice).toFixed(2)
                    : "",
                discountPrice: serialDetails
                  ? serialDetails.discountAmount
                  : "",
                _id: serialDetails ? serialDetails.itemId : "",
                totalAmount:
                  serialDetails && serialDetails.totalAmount
                    ? parseFloat(serialDetails.totalAmount).toFixed(2)
                    : "",
                createdDate: serialDetails ? serialDetails.dateCreated : "",
                stockAge: stockAge,
                index: "",
                action: "",
              };
            })
          : [];
      setItemSelectedRows(updatedItemValues);
      setBarcodeKey(true);
      if (updatedData.notes) {
        setNotesOpen(true);
      }
      setNotes(updatedData.notes);
      if (updatedData.termsandconditions) {
        setTermsOpen(true);
      }
      if (updatedData.autoamountroundoff) {
        setAdditionalChargesOpen(true);
      }

      setTermsConditions(updatedData.termsandconditions);
      const chargesValue =
        updatedData && updatedData.charges.length > 0
          ? updatedData.charges[0]
          : "";
      const chargeNameValue =
        updatedData && chargesValue ? chargesValue.chargeName : "";
      const chargeName = "No Tax Applicable";
      // setAmountPaid(updatedData.amountreceived);

      //total section data
      setTotalSectionData({
        ...totalSectionData,
        totalAmount: updatedData.netTotalAmount,
        autoRoundOffValue:
          updatedData.autoroundoffamount &&
          updatedData.autoroundoffamount !== undefined
            ? updatedData.autoroundoffamount
            : "",
        chargesData: chargeNameValue,
        siId: updatedData.siId,
        // netAmount: updatedData.NetAmount,
        additionalCharges:
          chargesValue && !isUndefined(chargesValue.chargeAmount)
            ? chargesValue.chargeAmount
            : 0,

        chargeId:
          chargesValue && !isUndefined(chargesValue._id)
            ? chargesValue._id
            : "",
      });
      setAutoRoundOffMethod(updatedData.type);
      setAutoRoundOff(updatedData.autoroundoff);
      setAdditionalOptions(chargeName);
      setBiller(updatedData.billerName);
      setBillerId(updatedData.billerId);
      setFileList([updatedData.authorizedsignatur]);
      setPreviewImage(updatedData.authorizedsignatur);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  console.log(partyModalData, "partyModaldata");
  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);
  //Prefix settings list

  const createPrefixSettings = () => {
    if (prefixSettings.prefix && prefixSettings.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 6000);
      const prefixList = {
        organizationId: organizationId,
        prefix: prefixSettings.prefix,
        sequenceNo: prefixSettings.seqNo,
        isEnable: invoiceShow === true ? true : false,
        isType: "isSalesReturn",
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(salesPrefixList));
          toast.success("Prefix updated successfully");
          const orgLastInvoiceNo =
            prefix_settings_list.lastprefixName +
            "" +
            prefix_settings_list.lastsequenceNo;
          setPoNo(
            !isEmpty(prefixSettings.seqNo)
              ? prefixSettings.prefix + "" + prefixSettings.seqNo
              : !isEmpty(updatedData) && updatedData !== undefined
              ? updatedData.returnsalesinvoiceNo
              : orgLastInvoiceNo
          );
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable == true) {
      setPrefixSettings({
        ...prefixSettings,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      setInvoiceShow(true);
      const orgLastInvoiceNo =
        prefix_settings_list.lastprefixName +
        "" +
        prefix_settings_list.lastsequenceNo;
      setOrgInvoiceNo(orgLastInvoiceNo);
      setPoNo(
        updatedData !== undefined && updatedData.returnsalesinvoiceNo
          ? updatedData.returnsalesinvoiceNo
          : orgLastInvoiceNo
      );
    } else {
      setPrefixSettings({
        ...prefixSettings,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
      setOrgInvoiceNo("");
      setPoNo(
        updatedData !== undefined && updatedData.returnsalesinvoiceNo
          ? updatedData.returnsalesinvoiceNo
          : ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>
            {" "}
            {!isEmpty(updatedData)
              ? "Update Sales Return"
              : "Create Sales Return"}{" "}
            | Mbook
          </title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24} className="border border-b-1 border-t-0 border-x-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-1 font-semibold"
              >
                {!isEmpty(updatedData)
                  ? "Update Sales Return"
                  : "Create Sales Return"}
              </h1>
            </div>
            <div className="flex">
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "13px",
                  }}
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                >
                  Settings <SettingOutlined />
                </div>
              </Tooltip>
              {/* <div
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                className="border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer"
              >
                Save & New
              </div> */}
              <div
                onClick={() => {
                  if (!isEmpty(updatedData)) {
                    updateSalesInvoiceApi();
                  } else {
                    createSalesInvoiceApi();
                  }
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                  pointerEvents: isButtonDisabled ? "none" : "",
                  opacity: isButtonDisabled ? 2 : "",
                }}
                className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
              >
                {!isEmpty(updatedData) ? "Update" : "Save"}
              </div>
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "sales-invoices-main-large-device w-[100%] pr-4 pl-5 pt-3"
              : windowDimensions.height > 830
              ? "sales-invoices-main-extra-large-device w-[100%] pr-4 pl-5 pt-3"
              : "sales-invoices-main w-[100%] pr-4 pl-5 pt-3"
          }
        >
          <Col span={24} className="add-sales-invoice-card">
            {/* File form section */}
            <Row className="border border-t-0 border-r-0 border-b-1">
              <Col
                span={12}
                className="flex border border-r-1 border-l-0 border-b-0 border-t-0"
              >
                <Row className="w-[100%]">
                  <Col span={24}>
                    <div className="w-[100%] flex justify-between border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                      <h1 className="ml-3 purchase-label text-[14px] font-medium">
                        Bill From
                      </h1>
                    </div>
                    <Row className="p-6">
                      {partyModal === true ? (
                        <Col
                          span={
                            !isEmpty(partyModalData._id) &&
                            !isEmpty(partyModalData.partyName)
                              ? 20
                              : 16
                          }
                          className="purchase-party-card"
                        >
                          <Row className="flex flex-col mb-1">
                            <Col
                              span={24}
                              className="flex justify-end pt-2 pr-2"
                            >
                              <CloseCircleOutlined
                                onClick={() => setPartyModal(false)}
                              />
                            </Col>
                            <Col span={24} className="pr-3 pl-3 pt-2 pb-2">
                              <AutoComplete className="mt-2 border border-none rounded-sm mb-2 w-[100%] mr-2">
                                <Input.Search
                                  size="large"
                                  placeholder="Search party by name or phone number"
                                  value={search}
                                  onChange={(e) => handleSearch(e)}
                                  // enterButton
                                />
                              </AutoComplete>
                            </Col>
                            <Col span={24} className="">
                              <div>
                                <div className="purchase-label flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 text-[14px]">
                                    Customer Name
                                  </h1>
                                  <p className="mr-2 text-[14px]">Balance</p>
                                </div>
                                <div className="purchase-label bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 font-semibold text-[14px]">
                                    Cash Sale
                                  </h1>
                                  <p className="mr-2 font-semibold text-[14px]">
                                    0.0
                                  </p>
                                </div>
                                <div
                                  className={
                                    vendorRows.length > 3
                                      ? "purchase-party-scroll"
                                      : ""
                                  }
                                >
                                  {vendorRows.length > 0
                                    ? vendorRows.map((data, index) => {
                                        const billingAddressData =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].address1
                                            : "";
                                        const billingAddressState =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].state
                                            : "";
                                        const billingAddressStateName =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].stateName
                                            : "";
                                        const billingAddressPincode =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].pincode
                                            : "";
                                        const billingAddressCity =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].city
                                            : "";

                                        const totalBillingAddress =
                                          !isEmpty(billingAddressData) &&
                                          billingAddressCity !== undefined &&
                                          billingAddressStateName !==
                                            undefined &&
                                          billingAddressPincode
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              ", " +
                                              billingAddressStateName +
                                              ", " +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              billingAddressCity &&
                                              billingAddressStateName ===
                                                undefined &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              " ," +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressPincode
                                            : "";

                                        return (
                                          <div
                                            key={index}
                                            className="cursor-pointer"
                                            onClick={() => {
                                              setPartyModal(false);
                                              setPartyModalData({
                                                partyName: data.partyName
                                                  ? data.partyName
                                                  : "",
                                                mobile: data
                                                  ? data.mobileNo
                                                  : "",
                                                gstIn: data.gstIn
                                                  ? data.gstIn
                                                  : "",
                                                _id: data._id,
                                                billingCityName:
                                                  billingAddressCity,
                                                billingAddressValue:
                                                  billingAddressData,
                                                totalBillingAddress:
                                                  totalBillingAddress,
                                                billingState:
                                                  billingAddressState,
                                              });
                                              setBillingPincode(
                                                billingAddressPincode
                                              );
                                              setBillingStateData(
                                                billingAddressStateName
                                              );
                                              dispatch(
                                                loadSearchImeiBarcodeList({
                                                  organizationId:
                                                    organizationId,
                                                  partyId: data._id,
                                                })
                                              );
                                            }}
                                          >
                                            {tableLoading ? (
                                              <Skeleton.Input
                                                style={{
                                                  margin: "6px 3px",
                                                  minWidth: "120%",
                                                  height: "60px",
                                                }}
                                                className="border border-b-1.5 border-x-0 border-t-0"
                                                // className="tabs-skeleton"
                                                active={true}
                                                size={"large"}
                                              ></Skeleton.Input>
                                            ) : (
                                              <div className="mb-2 purchase-label hover:bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                                <h1 className="ml-2 text-[14px]">
                                                  {data.partyName}
                                                </h1>
                                                <p className="mr-2 flex text-[14px]">
                                                  <p className="mr-2">
                                                    {data.openingbalanceType ===
                                                    "To Collect" ? (
                                                      <ArrowDownOutlined className="text-[green]" />
                                                    ) : (
                                                      ""
                                                    )}
                                                  </p>{" "}
                                                  {data.currentBalance &&
                                                    parseFloat(
                                                      data.currentBalance
                                                    ).toFixed(2)}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    : ""}
                                </div>
                              </div>
                            </Col>
                            {/* <Col span={24} className="p-3">
                              <div
                                onClick={() => {
                                  setCreatePartyModal(true);
                                  // dispatch(loadSalesInvoiceRecordsMetaData());
                                }}
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "13px",
                                }}
                                className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-2 pb-2 pl-10 pr-10"
                              >
                                <PlusOutlined /> Create Customer
                              </div>
                            </Col> */}
                          </Row>
                        </Col>
                      ) : !isEmpty(partyModalData._id) &&
                        !isEmpty(partyModalData.partyName) ? (
                        <Row
                          className={"ml-[-6px] w-[100%] mt-[-12px] mb-[-12px]"}
                        >
                          <Col span={24} className="flex">
                            <div className="relative w-[70%] sm:w-[100%] xs:w-[100%] md:w-[80%] border border-1 rounded-md pl-4 pr-4 pt-2 pb-2">
                              <h1 className="capitalize purchase-label text-[14px] font-semibold">
                                {!isEmpty(partyModalData.partyName) &&
                                  partyModalData.partyName}
                              </h1>
                              <div
                                className="flex"
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Address:
                                </p>
                                <p className="text-[12px]">
                                  {partyModalData &&
                                  partyModalData.billingAddressValue &&
                                  !isEmpty(partyModalData.billingAddressValue)
                                    ? partyModalData.billingAddressValue
                                    : ""}
                                </p>
                              </div>
                              <div
                                className="flex"
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  City:
                                </p>
                                <p className="text-[12px]">
                                  {partyModalData &&
                                  partyModalData.billingCityName &&
                                  !isEmpty(partyModalData.billingCityName)
                                    ? partyModalData.billingCityName
                                    : ""}
                                </p>
                              </div>
                              <div
                                className="flex"
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  State:
                                </p>
                                <p className="text-[12px]">
                                  {partyModalData &&
                                  partyModalData.billingState &&
                                  !isEmpty(billingStateData)
                                    ? `${billingStateData} - ${billingPincode}`
                                    : ""}
                                </p>
                              </div>
                              <div
                                className="flex"
                                style={{
                                  fontFamily: "Poppins",
                                }}
                              >
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Mobile:
                                </p>
                                <p className="text-[12px]">
                                  {partyModalData && partyModalData.mobile
                                    ? partyModalData.mobile
                                    : ""}
                                </p>
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-8px",
                                  }}
                                >
                                  <CloseCircleOutlined
                                    onClick={() => {
                                      setPartyModal(true);
                                      setPartyMode("Add");
                                      dispatch(loadParties(salesReturnList));
                                    }}
                                    className="cursor-pointer text-[16px] text-[red] "
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <div className="w-[60%] mt-[-6px]">
                          <div
                            onClick={() => {
                              setPartyModal(true);
                              setPartyMode("Add");
                              dispatch(loadParties(salesReturnList));
                            }}
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="text-center text-[#488dff] cursor-pointer border border-dashed border-2 border-blue-400 pl-8 pr-8 pt-4 pb-4"
                          >
                            <PlusOutlined /> Add Customer
                          </div>
                        </div>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={12} className={partyModal === true ? "pb-2" : ""}>
                <Row className="pl-3 pt-3">
                  <Col md={8} sm={12} lg={8} xs={12} className="pr-3">
                    <Typography className="input-label text-[10px]">
                      Sales Return No: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <Input
                      name="poNo"
                      value={poNo}
                      className="rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[27px] bg-[#e9ecf1]"
                      onChange={(e) => setPoNo(e.target.value)}
                      placeholder="Enter Invoice No"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "poNo",
                        poNo,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md={8} sm={12} lg={8} xs={12} className="pr-3">
                    <Typography className="input-label text-[10px]">
                      Sales Return Date: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <DatePicker
                      selected={poDate}
                      className="rounded-md w-[95%] pl-2 border-none h-[27px] hover:bg-[#e9ecf1] focus:bg-[#e9ecf1]  bg-[#e9ecf1]"
                      onChange={handlePoDateChange}
                      icon={<BiCalendar size={18} className="text-[#9e9e9e]" />}
                      placeholderText="Select Date"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "poDate",
                        poDate,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md={8} sm={12} lg={8} xs={12} className="pr-3">
                    <Typography className="input-label text-[10px]">
                      Biller: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <Select
                      name="biller"
                      value={biller}
                      onChange={(newValue) => setBiller(newValue)}
                      placeholder="Select Biller"
                      options={
                        recordsMetaData ? recordsMetaData.billerOptions : []
                      }
                      className="rounded-md w-[98%] pl-1 border-none hover:bg-[#e9ecf1] h-[27px]"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "biller",
                        biller,
                        "required"
                      )}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Item table section */}
            <Row className="border border-x-0 border-y-0 p-1 mt-2">
              <Col
                span={24}
                className="p-2 add-create-item-table  border border-x-0 border-y-0"
              >
                <table className="table-purchase-serial table-responsive">
                  <thead>
                    <tr
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <th className="w-[3%] table-head capitalize text-[12px] font-semibold">
                        No
                      </th>
                      <th className="w-[28%] table-head capitalize text-[12px] font-semibold">
                        <h1 className="input-purchase-label font-semibold">
                          {" "}
                          Barcode <p className="text-[red] ml-1">*</p>
                        </h1>
                      </th>
                      <th className="w-[15%] table-head capitalize text-[12px] font-semibold">
                        Model
                      </th>
                      <th className="w-[15%] table-head capitalize text-[12px] font-semibold">
                        Brand
                      </th>
                      {/* <th className="w-[8%] table-head capitalize text-[12px] font-semibold">
                        Age
                      </th>
                      <th className="w-[10%] table-head capitalize text-[12px] font-semibold">
                        Purchase.Price
                      </th> */}
                      <th className="w-[10%] table-head capitalize text-[12px] font-semibold">
                        Sell.Price
                      </th>
                      <th className="w-[10%] table-head capitalize text-[12px] font-semibold">
                        Discount
                      </th>
                      <th className="w-[13%] table-head capitalize text-[12px] font-semibold">
                        Net.Value
                      </th>
                      <th className="w-[3%] table-head capitalize text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => addItemsNew()}
                        >
                          <PlusCircleFilled className="text-[25px] text-[#2196f3]" />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemSelectedRows && itemSelectedRows.length > 0 ? (
                      itemSelectedRows.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            className="table-purchase-orders-row p-2"
                          >
                            <td className="table-sales-invoice-items-data font-medium text-center">
                              {index + 1}
                            </td>
                            <td className="table-sales-invoice-items-data font-semibold font-medium text-start">
                              {/* {data.itemName} */}
                              <ReactSearchAutocomplete
                                name="barcode"
                                key={arraySelectedId == index && barcodeKey}
                                items={
                                  barcodeOptions
                                    ? getFilteredBarcodes(data.barcode)
                                    : []
                                }
                                value={
                                  data.barcode
                                  // ? {
                                  //     label: data.barcode,
                                  //     value: data.barcodeName,
                                  //   }
                                  // : []
                                }
                                // value={data.barcode}
                                type="autoComplete"
                                resultStringKeyName="label"
                                showIcon={false}
                                inputSearchString={data.barcode}
                                showClear={false}
                                onClear={() => {
                                  itemSelectedChange("", "barcode", index);
                                  itemSelectedChange("", "model", index);
                                  itemSelectedChange("", "ramId", index);
                                  itemSelectedChange("", "ramName", index);
                                  itemSelectedChange("", "grade", index);
                                  itemSelectedChange("", "gradeName", index);
                                  itemSelectedChange("", "salesPrice", index);
                                  itemSelectedChange("", "barcodeName", index);
                                  itemSelectedChange("", "createdDate", index);
                                  itemSelectedChange("", "imeiCode", index);
                                  itemSelectedChange(
                                    "",
                                    "discountPrice",
                                    index
                                  );
                                }}
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e.target.value,
                                    "barcode",
                                    index
                                  )
                                }
                                onSelect={(e) => {
                                  itemSelectedChange(e, "barcode", index);
                                }}
                                placeholder="scan barcode"
                                wrapperStyle={{ width: "100%", zIndex: 20 }}
                                fuseOptions={fuseOptions} // Search on both fields
                                className="text-end hover:bg-[#e9ecf1] mb-[-6px]"
                                styling={{
                                  height: "28px",
                                  border: "1px solid #ced4da",
                                  borderRadius: "8px",
                                  backgroundColor: "white",
                                  boxShadow: "none",
                                  textAlign: "end",
                                  hoverBackgroundColor: "lightgray",
                                  color: "black",
                                  // marginBottom: "-3px",
                                  fontSize: "12px",
                                  fontFamily: "Poppins",
                                  iconColor: "green",
                                  clearIconMargin: "3px 8px 0 0",
                                  zIndex: 10,
                                }}
                              />
                              <Input
                                name="imeiCode"
                                value={data.imeiCode}
                                disabled
                                className="mt-[6px] h-[27px] rounded-md hover:bg-[#e9ecf1] focus:bg-[#e9ecf1]  bg-[#e9ecf1]"
                                placeholder="Enter IMEI No."
                                onChange={(e) =>
                                  itemSelectedChange(e, "imeiCode", index)
                                }
                              />
                            </td>
                            <td className="table-sales-invoice-items-data font-medium text-start">
                              {data.model}
                            </td>

                            <td className="table-sales-invoice-items-data font-medium text-start">
                              {data.brandName}
                            </td>
                            {/* <td
                              className={
                                data.stockAge > 30
                                  ? "text-[#bb1d0d] table-sales-invoice-items-data font-semibold text-start"
                                  : "text-[#08a35ae0] table-sales-invoice-items-data font-semibold text-start"
                              }
                              style={{
                                fontFamily: "Poppins",
                              }}
                            >
                              {data.stockAge ? data.stockAge + " Days" : ""}
                            </td>
                            <td className="table-sales-invoice-items-data font-medium text-center">
                              {data.purchasePrice}
                            </td> */}
                            <td className="table-sales-invoice-items-data font-medium">
                              <Input
                                name="salesPrice"
                                value={data.salesPrice}
                                className="p-2 h-[30px] text-end purchase-orders-inputs rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                                placeholder="price"
                                // prefix={"₹"}
                                disabled
                                onChange={(e) =>
                                  itemSelectedChange(e, "salesPrice", index)
                                }
                              />
                            </td>
                            <td className="table-sales-invoice-items-data font-medium">
                              <Input
                                name="discountPrice"
                                value={data.discountPrice}
                                className="p-2 h-[30px] text-end purchase-orders-inputs rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                                placeholder="price"
                                // prefix={"₹"}
                                disabled
                                onChange={(e) =>
                                  itemSelectedChange(e, "discountPrice", index)
                                }
                              />
                            </td>
                            <td className="table-sales-invoice-items-data font-medium text-center">
                              <Input
                                name="totalAmount"
                                value={data.totalAmount}
                                disabled
                                className="p-2 h-[30px] text-end purchase-orders-inputs rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                                placeholder="net price"
                                // prefix={"₹"}
                                onChange={(e) =>
                                  itemSelectedChange(e, "totalAmount", index)
                                }
                              />
                            </td>
                            <td className="table-sales-invoice-items-data font-medium">
                              {/* {index != 0 ? ( */}
                              <MinusOutlined
                                onClick={() => {
                                  removeItemsData(index);
                                  setArraySelectedId(index);
                                  setBarcodeKey(true);
                                  setTimeout(() => {
                                    setBarcodeKey(false);
                                  }, 0);
                                }}
                                type="primary"
                                height={25}
                                width={25}
                                className="border bg-[#d9180ad4] rounded-md p-2 text-[white] cursor-pointer text-[15px]"
                              />
                              {/* ) : (
                                ""
                              )} */}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={11} className="text-center">
                          {/* No Data Found */}
                        </td>
                      </tr>
                    )}
                    <tr
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="bg-[#e8f2f740] p-2 border border-x-0 pl-5 pr-5 mt-3"
                    >
                      <td className="text-center table-sales-invoice-items-data"></td>
                      <td className="text-center table-sales-invoice-items-data"></td>
                      <td className="text-center table-sales-invoice-items-data"></td>
                      <td className="text-center table-sales-invoice-items-data"></td>

                      {/* <td className="text-center table-sales-invoice-items-data"></td>
                      <td className="text-center table-sales-invoice-items-data"></td> */}
                      <td
                        colSpan={2}
                        className="text-end table-sales-invoice-items-data font-semibold text-[12px]"
                      >
                        Grand Total
                      </td>
                      <td
                        colSpan={2}
                        className="text-center table-sales-invoice-items-data"
                      >
                        <Input
                          name="totalDiscountAmount"
                          value={totals.totalDiscountAmount}
                          className="p-2 h-[28px] text-end rounded-md border-none purchase-orders-inputs hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                          placeholder="amount"
                          // prefix={"₹"}
                          onChange={(e) => handleTotalChange(e)}
                        />
                      </td>
                    </tr>
                    {/* <tr
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="bg-[#e8f2f740] p-2 border border-x-0 pl-5 pr-5 mt-3"
                    >
                      <td className="text-center table-sales-invoice-items-data"></td>
                      <td
                        colSpan={6}
                        className="w-[100%] text-end table-sales-invoice-items-data"
                      >
                        <div className="flex justify-end">
                          <h1 className="text-[11px] pr-1 pt-1">(-)</h1>
                          <div className="cursor-pointer bg-[#009688] text-[12px] rounded-md text-[white] pt-1 pr-2 pl-2 pb-1">
                            OTP Verify
                          </div>
                        </div>
                      </td>
                      <td className="text-end table-sales-invoice-items-data">
                        <Input
                          name="finalDiscountPrice"
                          value={totals.finalDiscountPrice}
                          className="p-2 h-[28px] text-end rounded-md border-none purchase-orders-inputs hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                          placeholder="Discount"
                          disabled
                          // prefix={"₹"}
                          onChange={(e) => {
                            handleTotalChange(e);
                            if (e) {
                              setTotals({
                                ...totals,
                                totalAmount: parseInt(
                                  totals.totalDiscountAmount - e
                                ),
                              });
                            }
                          }}
                        />
                      </td>
                      <td
                        colSpan={2}
                        className="text-center table-sales-invoice-items-data"
                      >
                        <Input
                          name="totalAmount"
                          value={totals.totalAmount}
                          disabled
                          className="p-2 h-[28px] text-end rounded-md border-none text-end purchase-orders-inputs hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] bg-[#e9ecf1]"
                          placeholder=""
                          onChange={(e) => handleTotalChange(e)}
                        />
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </Col>
            </Row>

            {/* Total section */}

            {/* Add notes, total section */}
            <Row className="border border-x-0 border-t-1 border-b-1">
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  {notesOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Notes
                        <CloseCircleOutlined
                          onClick={() => setNotesOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Enter your notes"
                        className="p-2 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => setNotesOpen(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Notes
                    </div>
                  )}
                  {termsOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Terms and Conditions{" "}
                        <CloseCircleOutlined
                          onClick={() => setTermsOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="termsConditions"
                        value={termsConditions}
                        onChange={(e) => setTermsConditions(e.target.value)}
                        placeholder="Enter your terms & conditions"
                        className="p-3 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      onClick={() => setTermsOpen(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Terms and Conditions
                    </div>
                  )}
                </div>
              </Col>
              <Col
                span={12}
                className="border border-r-1 border-l-0 border-y-0"
              >
                {/* Total , after gst section */}
                {discount === "Display Before Tax" ? (
                  <div className="p-3 pointer-events-none opacity-1 border border-x-0 border-b-1 border-t-0">
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-2">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 30,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2 text-[16px] pt-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 mt-2 text-[#488dff] cursor-pointer">
                        <div onClick={() => setDiscountOpen(true)}>
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice.toLocaleString("en-IN")
                              : // : itemSelectedRows.length > 1
                                // ? discountPriceTotal
                                0}
                          </h1>
                        </div>
                      </div>
                    )}

                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-2">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[30px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "160px",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                        >
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges.toLocaleString(
                                  "en-IN"
                                )
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="p-3 pointer-events-none opacity-1 border border-x-0 border-b-1 border-t-0">
                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-2">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[30px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          addonAfter={
                            <Select
                              value={additionalOptions}
                              onChange={(e) => setAdditionalOptions(e)}
                              style={{
                                width: "160px",
                                height: 25,
                              }}
                              defaultValue={"No Tax Applicable"}
                              options={[
                                {
                                  value: "No Tax Applicable",
                                  label: "No Tax Applicable",
                                },
                              ]}
                            />
                          }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                        >
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges.toLocaleString(
                                  "en-IN"
                                )
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 30,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 mt-2 text-[#488dff] cursor-pointer">
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                          onClick={() => setDiscountOpen(true)}
                        >
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice.toLocaleString("en-IN")
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="w-[100%] mt-1 purchase-label flex justify-between mb-2 cursor-pointer"
                  >
                    <Checkbox
                      type="checkbox"
                      name="autoRoundfOff"
                      height={14}
                      width={14}
                      value={autoRoundOff}
                      checked={autoRoundOff}
                      // defaultChecked
                      onChange={(e) => {
                        setAutoRoundOff(e.target.checked);
                        setTotalSectionData({
                          ...totalSectionData,
                          autoRoundOffValue: "",
                        });
                      }}
                      className="w-[50%] text-[#084d7b]"
                    >
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        className={"mt-2"}
                      >
                        {" "}
                        Auto Round Off{" "}
                      </p>
                    </Checkbox>
                    {/* {autoRoundOff === false ? ( */}
                    <Input
                      name="autoRoundOffValue"
                      value={totalSectionData.autoRoundOffValue}
                      onChange={(e) => handlePurchaseChange(e)}
                      disabled={autoRoundOff === false ? true : false}
                      addonBefore={
                        <Select
                          disabled={autoRoundOff === false ? true : false}
                          value={autoRoundOffMethod}
                          onChange={(e) => setAutoRoundOffMethod(e)}
                          style={{
                            width: 110,
                            height: 25,
                          }}
                          options={[
                            {
                              value: "add",
                              label: "+ Add",
                            },
                            {
                              value: "reduce",
                              label: "- Reduce",
                            },
                          ]}
                        />
                      }
                      type="text"
                      prefix={"₹ "}
                      placeholder="0"
                      className="w-[50%] mb-3 h-[25px]"
                    />
                    {/* ) : (
                      ""
                    )} */}
                  </div>
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="mt-3 font-semibold flex justify-between"
                  >
                    <h1 className="w-[50%] purchase-label text-[14px] mt-1">
                      Total Amount
                    </h1>
                    <h1 className="text-[16px]">
                      ₹.{" "}
                      {itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      autoRoundOff
                        ? Math.round(netAmount)
                        : itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          !autoRoundOff
                        ? netAmount && netAmount.toFixed(2)
                        : 0}
                    </h1>
                  </div>
                  {/* amount fully paid section */}
                </div>
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-1 mb-3 pt-3 border border-b-1 border-x-0 border-t-0 mb-3 cursor-pointer"
                >
                  <div className="mb-2 flex purchase-label text-[12px] justify-end pr-3">
                    Mark as Fully Paid
                    <Checkbox
                      type="checkbox"
                      name="fullyPaid"
                      height={14}
                      width={14}
                      // defaultChecked
                      value={fullyPaid}
                      onChange={(e) => setFullyPaid(e.target.checked)}
                      className="pl-2 text-[#084d7b]"
                    />
                  </div>
                  <div
                    style={{}}
                    className="mt-2 hidden w-[100%] pr-3 pl-3 pt-3 mb-5 flex justify-between"
                  >
                    <h1 className="w-[40%] font-normal purchase-label text-[12px] pl-3 mt-2">
                      Amount Received
                    </h1>
                    {/* <Input
                      name="amountPaid"
                      value={amountPaid}
                      disabled={fullyPaid === true ? true : false}
                      onChange={(e) => setAmountPaid(e.target.value)}
                      addonAfter={
                        <Select
                          value={amountPaidList}
                          disabled={fullyPaid === true ? true : false}
                          onChange={(e) => setAmountPaidList(e)}
                          style={{
                            width: 100,
                            height: 25,
                          }}
                          defaultValue={"credit"}
                          options={[
                            {
                              value: "credit",
                              label: "Credit",
                            },
                            {
                              value: "bank",
                              label: "Bank",
                            },
                            {
                              value: "cheque",
                              label: "Cheque",
                            },
                          ]}
                        />
                      }
                      type="text"
                      prefix={"₹ "}
                      placeholder="0"
                      className="w-[60%] h-[25px] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                    /> */}
                    <Select
                      value={amountPaidList}
                      disabled={fullyPaid === true ? true : false}
                      onChange={(e) => setAmountPaidList(e)}
                      style={{
                        width: 200,
                        height: 30,
                      }}
                      defaultValue={"creditbalance"}
                      options={[
                        {
                          value: "creditbalance",
                          label: "Credit Balance",
                        },
                        {
                          value: "current Balance",
                          label: "Current Balance",
                        },
                      ]}
                    />
                  </div>
                </div>
                {/* <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="border border-b-1 border-x-0 border-t-0 mb-1 cursor-pointer"
                >
                  <div className="w-[100%] pr-3 pl-3 mb-3 flex justify-between">
                    <h1 className="w-[40%] font-normal purchase-label text-[12px] pl-3 mt-1">
                      Balance Amount
                    </h1>
                    <h1 className="text-[16px] font-semibold">
                      ₹.{" "}
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? totalBalanceAmount
                        : 0}
                    </h1>
                  </div>
                </div> */}
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-2 p-3 text-[14px] purchase-label mb-2 cursor-pointer"
                >
                  <div className="flex justify-end">
                    <h1>Authorized signatory for</h1>
                    <p className="font-semibold ml-2 uppercase">
                      {organizationName}
                    </p>
                  </div>
                  <div className="flex justify-end mt-2 mb-1 ml-10">
                    <Upload
                      // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                      listType="picture-card"
                      // fileList={fileList}
                      onPreview={handlePreview}
                      accept=".png, .jpeg"
                      maxCount={1}
                      showUploadList={{
                        showDownloadIcon: true,
                        showRemoveIcon: false,
                      }}
                      beforeUpload={() => false}
                      onRemove={false}
                      onChange={handleImageChange}
                    >
                      {fileList.length > 0 ? null : uploadButton}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{
                          display: "none",
                        }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                    {!isEmpty(updatedData) ? (
                      <Image
                        src={fileList ? fileList[0] : ""}
                        // preview={false}
                        height={80}
                        width={150}
                        className="rounded-md"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {/* settings Field Modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Sales Return Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Sales Return Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Prefix
                  </Typography>

                  <Input
                    name="prefix"
                    value={prefixSettings.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(prefixSettings.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Sequence Number
                  </Typography>

                  <Input
                    name="seqNo"
                    value={prefixSettings.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(prefixSettings.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="mb-1"
                  >
                    Sales Invoice Number:{" "}
                    {prefixSettings.prefix && prefixSettings.seqNo
                      ? prefixSettings.prefix + "" + prefixSettings.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createPartyModal}
          title={
            partyMode === "Update"
              ? "Update New Customer"
              : "Create New Customer"
          }
          onOk={() => {
            if (!isEmpty(partyModalData.partyName)) {
              if (partyMode === "Update") {
                updatePartiesApi();
              } else {
                createPartiesApi();
              }
            } else {
              toast.error("customer Name field is required");
            }
          }}
          closeIcon
          maskClosable={false}
          okText={partyMode === "Update" ? "Update" : "Save"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setCreatePartyModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="">
                <Typography className="text-[gray] input-required-label uppercase flex">
                  Customer Name
                  <p className="text-[red]">*</p>
                </Typography>
                <Input
                  name="partyName"
                  value={partyModalData.partyName}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter name"
                  className="p-2"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {validations && !isEmpty(partyModalData.partyName)
                    ? "the party name field is required"
                    : ""}
                </p>
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="text-[gray] input-label mb-1 uppercase">
                  Mobile Number
                </Typography>
                <Input
                  name="mobile"
                  value={partyModalData.mobile}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter Mobile No"
                  className="p-2"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {validations && !isEmpty(partyModalData.mobile)
                    ? "the party name field is required"
                    : ""}
                </p>
              </Col>
              <Col span={24} className="mt-3">
                <div className="">
                  {addAddressShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                        >
                          Add Address
                        </h1>
                        <p
                          className="text-[#df121c]"
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                          onClick={() => setAddAddressShow(false)}
                        >
                          Remove
                        </p>
                      </Col>
                      <Col span={24} className="mt-3">
                        <Typography className="text-[gray] flex input-required-label uppercase">
                          Billing Address
                          <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Input.TextArea
                          name="billingAddress"
                          value={partyModalData.billingAddress}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter Billing Address"
                          className="p-3 h-[35px]"
                        />
                        <p className="text-start text-[red] mt-2 mb-3">
                          {validations && !isEmpty(partyModalData.partyName)
                            ? "the billing address field is required"
                            : ""}
                        </p>
                      </Col>
                      <Col span={12} className="mt-2 pr-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          State
                        </Typography>
                        <Select
                          style={{
                            width: 250,
                            height: 40,
                          }}
                          value={stateData}
                          onChange={(e) => setStateData(e)}
                          placeholder="Select State"
                          options={
                            recordsMetaData ? recordsMetaData.stateOptions : []
                          }
                        />
                      </Col>
                      <Col span={12} className="mt-2 pl-3">
                        <Typography className="text-[gray] input-label uppercase mb-1">
                          Pincode
                        </Typography>
                        <Input
                          name="pincode"
                          value={pincode}
                          onChange={(e) => {
                            const name = "pincode";
                            const validationRules = {
                              pincode: /^[0-9]*$/,
                            };
                            if (validationRules[name]) {
                              if (
                                validationRules[name].test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                setPincode(e.target.value);
                              }
                            }

                            axios
                              .get(
                                `https://api.postalpincode.in/pincode/${e.target.value}`
                              )
                              .then((res) => {
                                if (e.target.value.length === 6) {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName:
                                      res &&
                                      res.data &&
                                      res.data.length > 0 &&
                                      res.data[0].PostOffice !== null
                                        ? res.data[0].PostOffice[0].District
                                        : "",
                                  });
                                } else {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName: "",
                                  });
                                }
                              });
                          }}
                          maxLength={6}
                          placeholder="Enter pincode"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          City
                        </Typography>
                        <Input
                          name="cityName"
                          value={partyModalData.cityName}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter City"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-3 mb-1">
                        <div className="flex">
                          <Checkbox
                            type="checkbox"
                            name="sameAs"
                            height={14}
                            width={14}
                            defaultChecked
                            value={sameAs}
                            onChange={(e) => setSameAs(e.target.checked)}
                            className="text-[#084d7b]"
                          >
                            Same as Billing Address
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddAddressShow(true)}
                      className="mb-3 flex text-[#488dff] cursor-pointer"
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <PlusOutlined /> Add Address{" "}
                      <p className="text-[#df121c]">*</p>
                    </div>
                  )}
                  {addGstShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                        >
                          Add GST (Optional)
                        </h1>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                          className="text-[#df121c]"
                          onClick={() => setAddGstShow(false)}
                        >
                          Remove
                        </p>
                      </Col>

                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          GSTIN
                        </Typography>
                        <Input
                          name="gstIn"
                          value={partyModalData.gstIn}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter gstIn"
                          className="p-2 text-semibold"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddGstShow(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                      style={{
                        fontFamily: "Poppins",
                      }}
                    >
                      <PlusOutlined /> Add GSTIN (Optional)
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 bg-[#ffb8001a] purchase-label text-[12px] terms-conditions-card pr-3"
          >
            <h1 className="flex justify-center font-bold ml-15">
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                className="flex font-medium ml-2"
              >
                You can add Custom Fields from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Party settings
                </p>
              </p>
            </h1>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
        </Modal>
        {/* Add Serial Numbers Modal */}
        <Modal
          open={quantityShow}
          title="Add Serial Numbers"
          onOk={() => setQuantityShow(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setQuantityShow(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-2">
                  Item Name
                </Typography>
                <Typography className="purchase-label font-semibold text-[14px] mb-1">
                  Crab
                </Typography>
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Quantity
                </Typography>

                <Input
                  name="serialOpenStock"
                  value={serialOpenStock}
                  onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[6px] pl-[6px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder=""
                />
              </Col>

              <Col span={24} className="pr-4 mb-2">
                <div>
                  <table className="table-purchase-serial table-responsive">
                    <thead>
                      <tr className="table-row">
                        <th className="table-head">IMEI/Serial No</th>
                        <th className="table-head">Date Created</th>
                        <th className="table-head"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {serialData.map((data, index) => {
                        return (
                          <tr key={index} className="">
                            <td className="table-sales-invoice-items-data flex justify-between">
                              <Input
                                name="serialNo"
                                value={data.fieldName}
                                placeholder="Enter Custom Field name"
                                // className="w-[90%]"
                                onChange={(e) =>
                                  handleSerialDataChange(e, "serialNo", index)
                                }
                              />
                            </td>
                            <td className="table-sales-invoice-items-data">
                              {moment().format("Do MMM YYYY")}{" "}
                            </td>
                            <td className="table-sales-invoice-items-data">
                              {" "}
                              <DeleteOutlined
                                onClick={() => removeSerialData(index)}
                                type="primary"
                                className="ml-3 p-2 cursor-pointer"
                                size={"large"}
                              />{" "}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="table-sales-invoice-items-data">
                          <div
                            onClick={() => addSerialData()}
                            className="cursor-pointer text-[#1677ff]"
                          >
                            <PlusOutlined className="mr-2" />
                            Add New Serial No
                          </div>
                        </td>
                        <td
                          className="table-sales-invoice-items-data"
                          colSpan={2}
                        >
                          <div className="flex">
                            <BiQrScan className="mr-2 mt-1" />
                            <p>Scan Serial No</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>
        {/* Page Routing */}
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            history.push("/sales-return");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div
            className="text-center w-[100%]"
            style={{
              fontFamily: "Poppins",
            }}
          >
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
        {/* Purchase price Modal */}
        <Modal
          open={purchasePriceModal}
          title="Hide the Purchase price"
          onOk={() => {
            setPurchasePriceModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setPurchasePriceModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-4px",
            }}
          />

          <Col span={24} className="mb-10">
            <div
              style={{
                fontFamily: "Poppins",
              }}
            >
              <Typography className="text-center text-[14px] purchase-label">
                Are you sure you want to hide the
              </Typography>
              <Typography className="text-center ml-2  purchase-label font-semibold text-[14px]">
                purchase price in Invoice .?
              </Typography>
            </div>
          </Col>
        </Modal>

        {/* <CreateItems
          routeName="PurchaseOrders"
          modalOpen={createItemModal}
          modalClose={handleClose}
        /> */}
      </Row>

      {/* <Prompt
        when={!isEmpty(poNo) || !isEmpty(totalSectionData)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        // closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        // draggable
        style={{
          fontSize: "12px",
        }}
        // pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

CreateSalesReturn.propTypes = {
  onSignin: PropTypes.any,
  location: PropTypes.any,
  recordsMetaData: PropTypes.any,
};

export default CreateSalesReturn;
